<section class="title-bar content-padding first-item">
    <div class="wrapper nowrap">
        <h2 class="title-heading">{{collection?.id ? "Modifica" : "Nuovo"}} Collection</h2>
        <div class="item nowrap">
            <span class="data-row-left btn-container top-button-container"></span>
        </div>
    </div>
</section>

<section id="schedaPartner" class="content-padding darker">
    <div class="narrow-wrapper">
        <form class="has-cols" [formGroup]="collectionForm" (ngSubmit)="onSubmit()" *ngIf="collectionForm">
            <div class="">
                <fieldset>
                    <legend>BASIC INFORMATION:</legend>
                    <div class="col-48 grid-element">
                        <label for="ragioneSociale">NOME{{ collectionForm.get("collectionName") | required }}</label>
                        <input type="text" name="name" formControlName="collectionName">
                        <app-error-html-handler [ctrl]="collectionForm.get('collectionName')" [messages]="formValidationMsgs.collectionName"></app-error-html-handler>
                    </div>

                    <div class="col-50 grid-element">
                        <label for="image">Immagine{{ collectionForm.get("image") | required }}</label>
                        <div *ngIf="collection?.image && !removeFile">
                            <a style="float: right; width: auto; color: red; cursor: pointer;" (click)="deleteFile();">×</a>
                            <img [src]="imagePath" class="img-prodotto" style="max-height: 100px; cursor: pointer;" (click)="openImage(imagePath)" />
                        </div>
                        <input type="file" name="image" (change)="onFileSelect($event)" />
                        <app-error-html-handler [ctrl]="collectionForm.get('image')" [messages]="formValidationMsgs.image"></app-error-html-handler>
                    </div>

                    <div class="col-100 grid-element">
                        <label>Description</label>
                        <div [ngxSummernote]="summerNoteConfig" formControlName="bodyHtml"></div>
                        <app-error-html-handler [ctrl]="collectionForm.get('bodyHtml')" [messages]="formValidationMsgs.bodyHtml"></app-error-html-handler>
                    </div>
                    
                    <div class="" style="margin-top: 20px;">
                        <fieldset>
                            <legend>PROVINCE & PRODUCTS:</legend>
                            <div class="grid-element-full">
                                <label for="category">Province{{ collectionForm.get("province") | required }}</label>
                                <ng-select
                                    class="province"
                                    [multiple]="false" 
                                    [hideSelected]="true"
                                    [closeOnSelect]="true"
                                    formControlName="province"
                                    [attr.disabled]="true"
                                    (change)="handleProvinceChange($event)"
                                >
                                <ng-option *ngFor="let province of provinces" [value]="province.id"><b>{{ province?.provinceCode }}</b> {{ province?.province }}</ng-option>
                                </ng-select>
                                <app-error-html-handler [ctrl]="collectionForm.get('province')" [messages]="formValidationMsgs.province"></app-error-html-handler>
                            </div>

                            <!--
                            <div class="col-48 grid-element">
                                <label for="category">Scegli la Categoria Prodotto{{ collectionForm.get("productCategory") | required }}</label>
                                <ng-select
                                    class="province"
                                    [multiple]="false" 
                                    [hideSelected]="true"
                                    [closeOnSelect]="true"
                                    formControlName="productCategory"
                                    [attr.disabled]="true"
                                    (change)="handleProductCategoryChange($event)"
                                >
                                    <ng-option *ngFor="let productCategory of productCategories" [value]="productCategory.id">
                                        {{ productCategory?.categoryName }}
                                    </ng-option>
                                </ng-select>
                                <app-error-html-handler [ctrl]="collectionForm.get('productCategory')" [messages]="formValidationMsgs.province"></app-error-html-handler>
                            </div>
                            -->

                            <div class="expert-personal-info">
                                <div class="grid-element-full">
                                    <label style="position: relative; top: 20px;">Scegli la Categoria Prodotto{{ collectionForm.get("shopCollectionProductCategories") | required }}</label>
                                    <div>
                                        <div class="offer-products">
                                            <div class="" style="display: table; width: 100%;">
                                                <label for=""></label>
                                                <div style="display: table-cell; width: 19px;">
                                                    <i class="far fa-times-circle hvr-grow remove-product"></i>
                                                </div>
                                                <div class="product-q">
                                                    <div class="porduct-qty">
                                                        <div class="province-input">
                                                            <label for=""></label>
                                                            <ng-select formControlName="shopCollectionProductCategories" multiple="true" hideSelected="true" markFirst="true">
                                                                <ng-option *ngFor="let productCategory of productCategories" [value]="productCategory.id">
                                                                    {{ productCategory?.categoryName }}
                                                                </ng-option>
                                                            </ng-select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <app-error-html-handler [ctrl]="collectionForm.get('shopCollectionProductCategories')" [messages]="formValidationMsgs.shopCollectionProductCategories"></app-error-html-handler>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="grid-element-full">
                                <label class="original-label">
                                <input type="checkbox" [(ngModel)]="selectAllProducts" (change)="toggleSelectAll()" [ngModelOptions]="{standalone: true}">
                                Select All Filtered Products
                                </label>
                            </div>

                            <div class="grid-element-full" *ngIf="collectionForm.get('collectionProducts')?.controls.length > 0">
                                <label style="position: relative; top: 20px;">Prodotti{{ collectionForm.get('collectionProducts')?.controls[0].controls.product.id | required }}</label>
                                <div formArrayName="collectionProducts">

                                    <div class="offer-products" *ngFor="let collectionProductForm of collectionForm.get('collectionProducts')?.controls; let i = index">
                                        <div [formGroupName]="i" class="" style="display: table; width: 100%;">
                                            <label for=""></label>
                                            <div style="display: table-cell; width: 19px;">
                                                <i class="far fa-times-circle hvr-grow remove-product"  (click)="removeProduct(i)"></i>
                                            </div>
                                            <div class="product-q" formGroupName="product">
                                                <div class="porduct-qty">
                                                    <div class="province-input">
                                                        <label for=""></label>
                                                        <ng-select 
                                                            formControlName="id"
                                                            [searchable]="true" 
                                                            [clearable]="true"
                                                            [virtualScroll]="true"
                                                            >
                                                            <ng-option *ngFor="let product of products" [value]="product?.id" [disabled]="isProductOptionDisabled(product)">{{ product.name }}</ng-option>
                                                        </ng-select>
                                                    </div>
                                                </div>
                                            </div>
                                            <app-error-html-handler [ctrl]="collectionProductForm?.controls?.product.controls?.id" [messages]="formValidationMsgs?.collectionProducts?.product.id"></app-error-html-handler>
                                        </div>
                                    </div>
                                </div>
                                <div class="center mt-10" style="width: 100%;">
                                    <button class="btn mt-0" (click)="$event.preventDefault(); addProduct()">
                                        Aggiungi Prodotto<i class="ml-10 fas fa-plus"></i>
                                    </button>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                    
                </fieldset>
            </div>

            <div class="center mt-10">
                <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit()" [disabled] ="!collectionForm?.valid || btnDisabled">
                    Salva<i class="ml-10 far fa-save"></i>
                </button>
            </div>
        </form>
    </div>
</section>
